module.exports = __webpack_public_path__ + "img/product-mobile4.8ab70ea3.png";